import PageTitle from "~/library/PageTitle"
import LoadingWrapper from "~/library/LoadingWrapper"
import CatchCard from "~/library/CatchCard"
import CatchTable from "~/library/CatchTable"
import Pagination from "~/library/Pagination"
import NavigationLink from "~/library/NavigationLink"

import getAppConfig from "~/utils/getAppConfig"
import useFetchResource from "~/hooks/useFetchResource"
import { apiPacks } from "~/routes"
import Pack from "~/types/Pack"
import { formatCurrencyCents } from "~/utils/helpers"

const PacksList = () => {
  const { venueSlug } = getAppConfig()

  const {
    data: packs,
    refetch,
    metadata,
    isLoading,
  } = useFetchResource<{ packs: Pack[] }, "packs">(apiPacks.index.path({ venueSlug }), "packs", {
    page: "1",
  })

  const handlePageChange = (page: string) => {
    refetch({ page: page })
  }

  const formatActive = (active: boolean) => {
    return active ? (
      <span className="badge badge-lg bg-success">Active</span>
    ) : (
      <span className="badge badge-lg bg-secondary">Inactive</span>
    )
  }

  return (
    <LoadingWrapper isLoading={isLoading}>
      <PageTitle title="Packs" newItemPath="/packs/new" />

      <div className="row">
        <div className="col-12">
          <CatchCard className={"card-dark-theme"}>
            <CatchTable
              data={Array.isArray(packs) ? packs : []}
              emptyMessage="No Packs"
              columns={[
                {
                  key: "name",
                  header: "Name",
                  formatter: (name, data) => (
                    <NavigationLink type="packs" to={`/packs/${data.id}`}>
                      {name}
                    </NavigationLink>
                  ),
                },
                {
                  key: "priceCents",
                  header: "Price",
                  formatter: (priceCents) => formatCurrencyCents(priceCents),
                },
                {
                  key: "active",
                  header: "Status",
                  formatter: (active) => formatActive(active),
                },
              ]}
            />
            {metadata && (
              <Pagination
                metadata={metadata}
                onPageChange={(page: number) => handlePageChange(page.toString())}
              />
            )}
          </CatchCard>
        </div>
      </div>
    </LoadingWrapper>
  )
}

export default PacksList
